import { Box, Center, Grid, HStack, Text } from '@chakra-ui/react'
import { CheckDone, Reject } from 'src/components/icon'

type Props = {
  title: string
  supplementaryElement?: React.ReactNode
  isGrayedOut?: boolean
  icon?: 'Reject' | 'Check'
}

export const SignFlowBannerStatic: React.FC<Props> = ({
  title,
  supplementaryElement,
  isGrayedOut = false,
  icon = 'Check',
}) => {
  return (
    <Grid
      bg={isGrayedOut ? 'gray.400' : 'green.100'}
      p="4"
      borderRadius="lg"
      alignItems="center"
      templateColumns={{ base: '1fr', lg: '1fr 1fr' }}
      minH="72px"
      columnGap={1}
      rowGap={2}
    >
      <HStack flex="1" align="center" spacing="6">
        <Center w="40px" h="40px" color={isGrayedOut ? 'white' : 'green.700'}>
          {icon === 'Reject' ? (
            <Reject size="32px" />
          ) : (
            <CheckDone size="32px" />
          )}
        </Center>
        <Text
          fontSize="2xl"
          fontWeight="bold"
          color={isGrayedOut ? 'white' : 'green.700'}
        >
          {title}
        </Text>
      </HStack>
      {supplementaryElement !== undefined && (
        <Box overflow="hidden">{supplementaryElement}</Box>
      )}
    </Grid>
  )
}
